import { ValidatorFn, Validators } from '@angular/forms';
import { PolicyModels, QuotationModels } from '@wz-models';
import { WzDateValidators } from '@wz-validators';
import { subDays, subYears } from 'date-fns';

export const getMinMaxAgeByPackage = (
  pck: PolicyModels.PackageEnum,
  formula: QuotationModels.FormulaEnum,
): { minAge: number; maxAge: number } => {
  let minAge: any, maxAge: any;

  const formulasWith80YearOld = [
    QuotationModels.FormulaEnum.Sante5,
    QuotationModels.FormulaEnum.Sante6,
    QuotationModels.FormulaEnum.Sante7,
  ];

  switch (pck) {
    case PolicyModels.PackageEnum.Sante_InfinitySante:
      minAge = 18;
      maxAge = 85;
      break;
    case PolicyModels.PackageEnum.Sante_Acheel:
      minAge = 30;
      maxAge = 85;
      break;
    case PolicyModels.PackageEnum.Sante_Fidelity: {
      minAge = 50;
      maxAge = 85;

      if (formulasWith80YearOld.indexOf(formula) >= 0) {
        maxAge = 80;
      }
      break;
    }
    default:
      minAge = null;
      maxAge = null;
      break;
  }
  return { minAge, maxAge };
};

export const factoryAgeValidators = (
  dateEffet: Date,
  minAge: number,
  maxAge: number,
): ValidatorFn[] => {
  const validators = [Validators.required];

  if (!dateEffet) {
    return validators;
  }

  if (minAge != null) {
    validators.push(
      WzDateValidators.max(subDays(subYears(dateEffet, minAge), 1)),
    );
  }

  if (maxAge != null) {
    validators.push(
      WzDateValidators.min(
        new Date(subYears(dateEffet, maxAge).getFullYear(), 0, 1),
      ),
    );
  }

  return validators;
};
